module.exports = __webpack_public_path__ + "static/img/best-cfd-2022.e59d486.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/best-cfd-2022.svg
// module id = iIEV
// module chunks = 4